export default{
    lab: "Lab Name",
    date: "Date",
    result: "Result",
}